<div class="data-container">
    <div class="ilustrate">
        <img src="icons/empty.svg" alt="No file" class="found">
    </div>

    <div class="text-info">
        <h3>{{ titulo }}</h3>
        <p>{{ descricao }}</p>
      </div>
      
</div>